import {CommonModule} from '@angular/common';
import {ErrorHandler, NgModule, Optional, SkipSelf} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import {RouterStateSerializer, StoreRouterConnectingModule} from '@ngrx/router-store';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';

import {AppState, metaReducers, reducers, selectRouterState} from './store/core.state';

import {AuthEffects} from './store/auth/auth.effects';
import {
  selectAuth,
  selectAuthError,
  selectAuthIsLoading,
  selectAuthPersonaId,
  selectAuthToken
} from './store/auth/auth.selectors';

import {
  authAccessTokenFailure,
  authAccessTokenRequest,
  authAccessTokenSuccess,
  authDPIRedirect,
  authLoginFailure,
  authLoginRequest,
  authLoginSuccess,
  authLogout
} from './store/auth/auth.actions';

import {ROUTE_ANIMATIONS_ELEMENTS, routeAnimations} from './animations/route.animations';
import {AnimationsService} from './services/animations.service';
import {AppErrorHandler} from './services/app-error-handler.service';
import {CustomSerializer} from './router/custom-serializer';
import {LocalStorageService} from './services/local-storage.service';
import {HttpErrorInterceptor} from './interceptors/http-error.interceptor';
import {NotificationService} from './services/notification.service';
import {GxErrorInterceptor} from './interceptors/gx-error-interceptor';
import {TokenInterceptor} from './interceptors/auth-token.interceptor';
import {RoleGuard, AuthGuard} from './guards';
import {ConfigService} from "../shared";

export {
  authDPIRedirect,
  selectAuth,
  selectAuthToken,
  selectAuthPersonaId,
  selectAuthError,
  selectAuthIsLoading,
  authLoginRequest,
  authAccessTokenRequest,
  authAccessTokenSuccess,
  authAccessTokenFailure,
  authLoginSuccess,
  authLoginFailure,
  authLogout,
  routeAnimations,
  AppState,
  LocalStorageService,
  ROUTE_ANIMATIONS_ELEMENTS,
  AnimationsService,
  AuthGuard,
  RoleGuard,
  selectRouterState,
  NotificationService
};

@NgModule({
  imports: [
    // angular
    CommonModule,
    HttpClientModule,
    // ngrx
    StoreModule.forRoot(reducers, {metaReducers}),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([AuthEffects]),
    StoreDevtoolsModule.instrument(
      {
        name: 'Seguros Visor',
        logOnly: ConfigService.isProduction()
      })
  ],
  declarations: [],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: GxErrorInterceptor, multi: true},
    {provide: ErrorHandler, useClass: AppErrorHandler},
    {provide: RouterStateSerializer, useClass: CustomSerializer}
  ],
  exports: []
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
